import { render, staticRenderFns } from "./AgentSideMenu.vue?vue&type=template&id=af57a47e&scoped=true"
import script from "./AgentSideMenu.vue?vue&type=script&lang=ts"
export * from "./AgentSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./AgentSideMenu.vue?vue&type=style&index=0&id=af57a47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af57a47e",
  null
  
)

export default component.exports